import templateUrl from './contact-documents.tpl.html';
import Documents from '../../../../../store/documents/main/index';
import createModalTemplate from '../../../../documents/main/directives/documents/views/editor-modal.tpl.html';

class ContactDocumentsCtrl {
    constructor(model, $injector, $uibModal) {
        this.model = model;
        this.injector = $injector;
        this.uibModal = $uibModal;
        this.documentCreateService = this.injector.get('DocumentCreateService');
        this.state = $injector.get('$state');
    }

    $onInit() {
        this.loadDocuments();
    }

    loadDocuments() {
        this.store = new Documents(this.model, {injector: this.injector});
        // this.store.commit('setVisible', ['title', 'created_at']);
        this.store.commit('setPrefix', 'contacts/' + this.contact.id);
        this.store.commit('setVm', this);

        // this.store.commit('addAction', {
        //     key: 'download',
        //     text: 'Download',
        //     icon: 'upload',
        //     level: 'row',
        //     vm: 'downloadDocument'
        // });
        //
        // this.store.commit('addAction', {
        //     key: 'download',
        //     text: 'Download',
        //     icon: 'upload',
        //     level: 'row',
        //     vm: 'downloadDocument'
        // });

        this.store.commit('setVm', this);
    }

    goToDetails({action, row}) {
        this.state.go('app.documents.main.details', {id: row.id});
    }


    downloadDocument(action) {
        this.model.download({
            id: action.row.id,
            title: action.row.title
        });
    }

    addNew() {
        this.documentCreateService.startNewSingleDocumentWizard('contacts', {
            filters: [
                {
                    'field': 'id',
                    'operator': '=',
                    'value': this.contact.id
                }
            ],
            count: 1
        });
    }
}

ContactDocumentsCtrl.$inject = [
    'Document',
    '$injector',
    '$uibModal'
];

angular
    .module('festzelt-os.contacts')
    .component('contactDocuments', {
        bindings: {
            contact: '='
        },
        controller: ContactDocumentsCtrl,
        controllerAs: 'vm',
        templateUrl: templateUrl
    });




// WEBPACK FOOTER //
// ./src/app/pages/contacts/directives/sections/documents/contact-documents.js